import {common_utils} from "../common/common_utils";
import {slots_utils} from "../../../untils/slots_utils";

function slots_tool()
{

}

slots_tool.isPhone = false;

slots_tool.isFree = function(obj, data)
{
    obj.hasfree = true
    if(data.isFree != 0)
    {
      obj.isfree = obj.$t('lang.str_t');
    }
    else
    {
      obj.isfree = obj.$t('lang.str_f');
    }
}

slots_tool.setMap = function(map, rows, colum)
{
  let mapTmp = [];
  for (var j = 0; j < rows; j++)
  {
    for (var i = 0; i < colum; i++)
    {
      let value = map[i][j];
      let obj = slots_tool.splitItemValue(value);
      mapTmp.push(obj)
    }
  }
  return mapTmp;
}

slots_tool.splitItemValue = function(data)
{
  let item = {};
  let one_map = data.split("_");
  if(one_map&&one_map.length>1)
  {
    for(let i = 0;i < one_map.length;i++)
    {
      let value = one_map[i];
      if(i === 0)
      {
        item.itemValue = value;
      }
      else if(i === 1)
      {
        item.itemNum = parseInt(value);
        item.itemNumStr = value;
      }
      else if(i === 2)
      {
        item.multiple = parseInt(value);
      }
    }
  }
  else
  {
    item.itemValue = data;
    item.itemNum = 1;
    item.multiple = 1;
  }
  item.isWin =  false;
  return item;
}



slots_tool.CenterPoints= function(div, type)
{
    // if(div)
    // {
    //     const rect = div.getBoundingClientRect();
    //     let rect_y = rect.top + rect.height / 2 + (type * 2);
    //     if(type > 10)
    //     {
    //       rect_y  = rect.top + rect.height / 2 - (type * 2);
    //     }
    //     return {
    //       x: rect.left + rect.width / 2,
    //       y: rect_y,
    //     };
    // }
    // return {x:0,y:0};
  if(div)
  {
    let offsetY = 5;
    if(slots_tool.isPhone)
    {
      offsetY = 2;
    }
    const rect = div.getBoundingClientRect();
    let symbol = type % 2 !== 0 ? 1:-1
    let rect_y = rect.top + rect.height / 2 + ((type%10) * offsetY)*symbol;
    return {
      x: rect.left + rect.width / 2,
      y: rect_y,
    };
  }
  return {x:0,y:0};

}


slots_tool.clearLines= function() {
  const divs = document.getElementsByClassName("line");
  if (divs) {
    for(var i = 0; i < divs.length; i++) {
      document.body.removeChild(divs[i])
    }
  }
}

slots_tool.drawLines = function(from, to, type)
{
    console.log("drawLines")
    const fromDiv = document.getElementById(from);
    const toDiv = document.getElementById(to);

    // const fromCenterPoints = () => {
    //   const rect = fromDiv.getBoundingClientRect();
    //   return {
    //     x: rect.left + rect.width / 2,
    //     y: rect.top + rect.height / 2 + (type * 5)
    //   };
    // }
    // const toCenterPoints = () => {
    //   const rect = toDiv.getBoundingClientRect();
    //   return {
    //     x: rect.left + rect.width / 2,
    //     y: rect.top + rect.height / 2 + (type * 5)
    //   };
    // }
    // 绘制折线，可以根据需要使用SVG、CSS伪元素等方式
    // 这里以创建一个<div>元素作为折线的示例
    const line = document.createElement('div');
    line.classList.add('line');
    // document.body.appendChild(line);

    var color = "";
    switch(type % 10) {
      case 1:
        color = "red";
        break;
      case 2:
        color = "green";
        break;
      case 3:
        color = "blue";
        break;
      case 4:
        color = "yellow";
        break;
      case 5:
        color = "purple";
        break;
      case 6:
        color = "orange";
        break;
      case 7:
        color = "cyan";
        break;
      case 8:
        color = "pink";
        break;
      case 9:
        color = "brown";
        break;
      case 10:
        color = "gray";
        break;
    }

    line.style.position = 'absolute';
    line.style.zIndex = '999';
    line.style.borderTop = '4px solid ' + color;

    const start = slots_tool.CenterPoints(fromDiv,type);
    const end = slots_tool.CenterPoints(toDiv,type);
    const length = Math.sqrt((end.x - start.x) ** 2 + (end.y - start.y) ** 2) + 4;
    const angle = Math.atan2(end.y - start.y, end.x - start.x) * 180 / Math.PI;

    line.style.width = length + 'px';
    line.style.left = start.x + 'px';
    line.style.top = start.y + 'px';
    line.style.transformOrigin = 'left top';
    line.style.transform = `rotate(${angle}deg)`;
    document.body.appendChild(line);
    return line;
}

slots_tool.setWinValueByList= function(winValueList,mapList,odd_map,index_mul = 0)
{
    for (let i = 0; i < mapList.length; i++)
    {
       let dataMap = mapList[i];
       slots_tool.setWinValue(winValueList,dataMap,odd_map,index_mul);
    }
}

slots_tool.setWinValueByObject= function(winValueList,dataMap,odd_map,index_mul = 0)
{
    for (let key in dataMap)
    {
        let detail = dataMap[key];
        detail = slots_tool.winInfo(odd_map,detail,index_mul);
        winValueList.push(detail.winValue);
        dataMap[key] = detail;
    }
}


slots_tool.setWinValue= function(winValueList,data,odd_map,index_mul = 0)
{
  if(Array.isArray(data)){
    slots_tool.setWinValueByList(winValueList,data,odd_map,index_mul);
  }else{
    slots_tool.setWinValueByObject(winValueList,data,odd_map,index_mul);
  }

}

slots_tool.read_win_data = function(mapDicDetail,win_data)
{
    let key = win_data.s + "_" + win_data.c
    var detail = mapDicDetail[key]
    if(detail){
      detail.lines = detail.lines+1;
      detail.linesInfo.push(win_data.l)
    }else{
      detail = {};
      detail.lines = 1
      detail.key = win_data.s
      detail.linesInfo = []
      detail.linesInfo.push(win_data.l)
      detail.length = win_data.c
    }
   mapDicDetail[key] = detail
}

slots_tool.read_win_data2 = function(mapDicDetail,win_data)
{
  let key = win_data.s+"_"+win_data.l
  var detail = mapDicDetail[key]
  if(detail){
    detail.lines = detail.lines+1;
    detail.linesInfo.push(win_data.line)
    detail.wins.push(win_data.w)
  }else{
    detail = {};
    detail.lines = 1
    detail.key = win_data.s
    detail.linesInfo = []
    detail.linesInfo.push(win_data.line)
    detail.wins = []
    detail.wins.push(win_data.w)
    detail.length = win_data.l
  }
  mapDicDetail[key] = detail
}


slots_tool.detailBet = function(data){
  if(data && data.detail){
     return data.detail.bet;
  }
  return 0;
}

slots_tool.isExtTip = function (data,obj = null)
{
  return common_utils.isExtTip(data);
}
slots_tool.isFree = function(data){
  return common_utils.isFree(data);
}

slots_tool.isExt = function(data){
  return common_utils.isExt(data);
}

slots_tool.TotalValueByData = function (list,data,mul,extra = null,mulNum = 0,bonusWin = 0,jackpotWin = 0)
{
    if(extra == null){
       //extra = common_utils.isExt(data)
      extra = false;
    }
    return slots_tool.TotalValue(list,slots_tool.detailBet(data),mul,common_utils.isFree(data),extra,mulNum,bonusWin,jackpotWin)
}


slots_tool.TotalValue = function (list,bet,mul,isFree,extra = false,mulNum = 0,bonusWin = 0,jackpotWin = 0,isHalfBet = false)
{
  console.log("slots_tool.TotalValue")
  let len = list.length;
  if(len<=0)
  {
    return null;
  }
  let winValueTotalTip = "";
  let gameBetStrTip = "投注大小";
  let winValueTotal = "(";
  let winValueNum = 0;
  let gameBet = bet / 100;
  let gameBetStr = gameBet.toString();

  if(extra)
  {
    gameBetStr =  gameBet + "/1.5" ;
  }

  if(isHalfBet > 0)
  {
    gameBetStr += gameBet + " / 2 " ;
    gameBetStrTip +=   " / 2 " ;
  }

  if(mulNum >= 1)
  {
    gameBetStr =  gameBetStr + "X" + mulNum ;
    gameBetStrTip +=  "x 奖金倍数"
  }
  let totalValue = 0
  for (let i = 0; i < len; i++)
  {
    let winValue = list[i]
    winValueNum += winValue;
    let winValueStr = common_utils.roundToFixed(winValue);
    if(i < len-1)
    {
      winValueTotal += winValueStr + "+";
    }
    else
    {
      if(mulNum > 1)
      {
        winValueNum = winValueNum * mulNum;
      }
      totalValue = ((winValueNum * gameBet) /mul);
      if(isHalfBet > 0)
      {
        totalValue = totalValue / 2;
      }
      if(extra)
      {
        totalValue = totalValue / 1.5;
      }
      if(isFree)
      {
        winValueTotal += winValueStr + ") X ( " + gameBetStr + " / " + mul + " ) = " + common_utils.roundToFixed(totalValue,4);
        winValueTotalTip += "符号赔付值 X " + "底分 ( "+ gameBetStrTip + " / " + mul  + " ) = 总赢"
      }
      else
      {
        totalValue = totalValue - gameBet;
        winValueTotal += winValueStr + ") X ( " + gameBetStr + " / " + mul + " ) - " + gameBet + " = " + common_utils.roundToFixed(totalValue,4);
        winValueTotalTip += "符号赔付值 X " + "底分 ( "+ gameBetStrTip + " / " + mul +   " ) - 投注大小 = 总赢值"
      }
    }
  }
  if(bonusWin>0)
  {
    winValueTotal  = "( " + winValueTotal +" ) + " + bonusWin + "=" + (totalValue + bonusWin) ;
    winValueTotalTip = "( " +winValueTotalTip+ " ) + 特殊游戏奖金 = 总赢"
  }
  if(jackpotWin>0)
  {
    winValueTotal  = "(" + winValueTotal +") + " + jackpotWin + "=" + (totalValue + jackpotWin) ;
    winValueTotalTip = "( " +winValueTotalTip+ " ) + 奖池奖金 = ( 总赢 + 奖池奖金 )"
  }
  return [winValueTotal,winValueTotalTip];

}

slots_tool.winInfo = function (odd_map,detail,index_mul)
{

    let lines = detail.lines;
    if(lines <= 0)
    {
        return null;
    }
    let odd = this.read_odd(odd_map,detail.key, detail.length)
    if(index_mul>0)
     {
         let winValue = odd * lines * index_mul
        detail.winInfo = odd + "X" + lines  + "X" + index_mul +"= " + common_utils.roundToFixed(winValue);
         detail.winValue = winValue;
     }
    else{
         let winValue = odd * lines
         detail.winInfo = odd + "X" + lines +"= " + common_utils.roundToFixed(winValue) ;
         detail.winValue = winValue;
    }
    return detail;
}

slots_tool.read_odd = function(odd_map,key,lines)
{
    let line = lines - 1;
    let list = odd_map[key]
    if(list && line > 0 && list.length > line)
    {
      return list[line]
    }
    return 0
}

slots_tool.read_index_mul = function(mul_array,index,type = 0)
{
  // console.log("read_index_mul")
  if(mul_array == null||mul_array.length <= type)
  {
     return 0;
  }
  let mul = mul_array[type];
  if(mul == null || mul.length <= 0)
  {
    return 0;
  }
  let len = mul.length
  if(index >= len)
  {
    return mul[len-1]
  }
  return mul[index]
}

slots_tool.drawSlotLines = function (this1,win_lines,head_name){
  this1.$nextTick(() => {
    this1.$nextTick(() => {
      this1.$nextTick(() => {
        setTimeout(() => {
          this1.clearLines();
          for(let key in win_lines)
          {
              let win_line = win_lines[key];
              for (let j = 0; j < win_line.length; j++)
              {
                    let win_item =  win_line[j]
                    for (let index = 0; index < win_item.length-1; index++)
                    {
                        let fromLine = win_item[index];
                        let nextLine = win_item[index+1];
                        if(fromLine ||nextLine)
                        {
                            if(common_utils.isNull(head_name))
                            {
                                 head_name = "m";
                            }
                            let fromIndex = head_name + "_" + key + "_" + fromLine.i;
                            let toIndex = head_name + "_"  + key + "_" + nextLine.i;
                            slots_tool.drawLines(fromIndex,toIndex, j)
                        }
                    }
              }
          }
        }, 1000);
      })
    })
  })
}


slots_tool.setLineIdName = function (lineId,index){
  if(common_utils.isNull(lineId))
  {
    lineId = 0;
  }
  return "m_" + lineId + "_" + index;
}

slots_tool.setMapsLineIdName = function (lineId,index,subIndex){
  return "m_" +  lineId.toString()  + index + "_" + subIndex;
}

slots_tool.getSubLineHeadName = function (lineId)
{
  return "s"+lineId;
}


slots_tool.pushSubMapLine = function (obj,key,value)
{
    if(common_utils.isNull(obj))
    {
        return obj;
    }
    obj[key] = value
}

slots_tool.checkIncludeIndex = function(list,index)
{
  if(common_utils.isNull(list)||common_utils.isNull(index))
  {
      return false;
  }
  for (let i = 0; i < list.length; i++)
  {
    let id = list[i];
    if(id === index)
    {
       return true
    }
  }
  return false;
}

slots_tool.gameImgAreaClass = function (classId)
{
    let className = "gameImgArea";
    if(common_utils.isNull(classId) === false && (classId && classId.length > 0))
    {
      return className + "_" + classId;
    }
    return className;
}

slots_tool.gameImgDetailClass = function (classId)
{
    let className = "gameImgDetail";
    if(common_utils.isNull(classId) === false && (classId && classId.length > 0))
    {
      return className+"_"+classId;
    }
    return className;
}

slots_tool.matchDeepColor = function (mapIndex,index)
{
  console.log("matchDeepColor")
  if(common_utils.isNull(mapIndex))
  {
    return false;
  }
  return mapIndex.some(item => item === index)
}

slots_tool.matchScatterWin = function (item,scatterWin,check_scatter_win,scatterItem)
{
  // console.log("matchScatterWin")
  if(common_utils.isNull(check_scatter_win)||!check_scatter_win)
  {
    return false
  }
  if(common_utils.isNull(item))
  {
    return false
  }
  if(common_utils.isNull(scatterWin))
  {
    return false
  }
  if(common_utils.isNull(scatterItem))
  {
      scatterItem = "S"
  }
  return ((scatterWin > 0) && (item == scatterItem));
}


slots_tool.matchSubDeepColor = function (mapIndex,index, subIndex){
  //console.log("matchDeepColor")
  if(common_utils.isNull(mapIndex))
  {
    return false;
  }
  return mapIndex[index].some(item => item === subIndex)
}

slots_tool.matchDeppFreeColor = function (freeId,index,mapList,remain_free_count = 3,checkFreeColor = false,sum_rows = 3, sum_colums = 5){

  if(common_utils.isNull(checkFreeColor)||!checkFreeColor)
  {
    return false
  }
  var trigFree = false
  let s = new slots_utils();
  if(common_utils.isNull(remain_free_count))
  {
    remain_free_count = 3;
  }
  if(common_utils.isNull(sum_rows))
  {
    sum_rows = 3;
  }
  if(common_utils.isNull(sum_colums))
  {
    sum_colums = 3;
  }

  trigFree = s.showSlotsFreeBlock(freeId, mapList, remain_free_count,sum_rows, sum_colums )
  if (trigFree)
  {
    return mapList[index] === freeId
  }
  else
  {
    return false
  }
}

slots_tool.matchSubDeppFreeColor = function (index, subIndex, freeId,subMapList,remain_free_count,checkFreeColor = false,sum_rows = 3, sum_colums = 5){

    if(common_utils.isNull(checkFreeColor)||!checkFreeColor)
    {
      return false
    }
    var trigFree = false
    let s = new slots_utils();
    if(common_utils.isNull(remain_free_count))
    {
      remain_free_count = 3;
    }
    if(common_utils.isNull(sum_rows))
    {
      sum_rows = 3;
    }
    if(common_utils.isNull(sum_colums))
    {
      sum_colums = 3;
    }
    trigFree = s.showSlotsFreeBlock(freeId, subMapList[index], remain_free_count,sum_rows, sum_colums )
    if (trigFree)
    {
      return subMapList[subIndex] === freeId
    }
    else
    {
      return false
    }
}

slots_tool.matchDeppFreeColorTable = function (freeId,index,mapList,remain_free_count,checkFreeColor = false,table =   [4, 5, 5, 5, 4])
{
    if(common_utils.isNull(checkFreeColor)||!checkFreeColor)
    {
       return false
    }
    var trigFree = false
    if(common_utils.isNull(remain_free_count))
    {
        remain_free_count = 3;
    }
    if(common_utils.isNull(table)||table.length === 0)
    {
      table = [4, 5, 5, 5, 4];
    }
    let s = new slots_utils();
    trigFree = s.showSlotsFreeBlockTable(freeId, mapList, remain_free_count,table)
    if (trigFree)
    {
      return mapList[index] === freeId
    }
    else
    {
      return false
    }
}

slots_tool.matchSubDeppFreeColorTable = function (index, subIndex,freeId,subMapList,remain_free_count,checkFreeColor = false,table =   [4, 5, 5, 5, 4])
{
    // console.log("matchSubDeppFreeColorTable")
    if(common_utils.isNull(checkFreeColor)||!checkFreeColor)
    {
      return false
    }
    var trigFree = false
    if(common_utils.isNull(remain_free_count))
    {
      remain_free_count = 3;
    }
    if(common_utils.isNull(table)||table.length === 0)
    {
      table = [4, 5, 5, 5, 4];
    }
    let s = new slots_utils();

    trigFree = s.showSlotsFreeBlockTable(freeId, subMapList[index],remain_free_count,table)
    if (trigFree)
    {
        return subMapList[index][subIndex] === freeId
    }
    else
    {
        return false
    }
}

export {
  slots_tool
};



// WEBPACK FOOTER //
// ./src/components/slots/slots_tool.js